(function ($) {
    $(document).ready(function () {
        let observer, $nextPage;
        initInfiniteScroll();
        $(document.body).on('filter', initInfiniteScroll);

        function initInfiniteScroll() {
            if (observer) {
                observer.disconnect();
            }
            $nextPage = $('.posts-navigation .nav-previous a');
            if (!$nextPage.length) return;

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadNextPage();
                    }
                });
            });
            observer.observe($nextPage.get(0));
        }

        function loadNextPage() {
            if (observer) observer.disconnect();
            const url = $nextPage.attr('href');
            const $pagination = $('.posts-navigation');

            $pagination.hide();
            const $loader = $(`<div class="lds-ripple"><div></div><div></div></div>`).insertAfter($pagination);

            $.ajax({
                url,
                type: 'GET',
                contentType: 'application/json',
                dataType: 'html'
            }).done(function (data) {
                $pagination.show();
                $loader.remove();

                $('.post-items').append($('.post-items > *', data));
                const paginationHTML = $('.posts-navigation', data);
                $pagination.html(paginationHTML);
                $(document).trigger('infinite-scroll-loaded');

                if (!paginationHTML.has('.nav-previous').length) {
                    $pagination.empty();
                    return;
                }
                initInfiniteScroll();
            });
        }
    });

})(jQuery);
